/**
 * Frontend-owned public contracts and display helpers.
 * The API remains authoritative for authorization and business rules.
 */
export type Role =
  | 'superadmin'
  | 'admin'
  | 'instructor'
  | 'mentor'
  | 'support'
  | 'student';

export const SITE = {
  name: 'MAKTech Academy',
  base: 'https://maktechacademy.com',
  desc: 'Live and recorded online courses taught by industry experts. Track progress, build real projects and earn verifiable certificates.',
  hotline: '16910',
  whatsapp: '8801896016252',
  intl: '+880 9610916910',
  supportEmail: 'support@maktechacademy.com',
  certPrefix: 'MAK-',
  commissionPct: 30,
} as const;

export function formatBDT(minor: number): string {
  if (minor === 0) return 'Free';
  const taka = minor / 100;
  return `৳${taka.toLocaleString('en-US', {
    minimumFractionDigits: Number.isInteger(taka) ? 0 : 2,
    maximumFractionDigits: 2,
  })}`;
}

export function takaToMinor(taka: number): number {
  return Math.round(taka * 100);
}
